import { Link } from 'react-router-dom';
import { TaskItemHeader } from './TaskItemHeader';
import type { TaskItem as TaskItemType, TaskItemProps } from './types';

export function TaskItem<T extends TaskItemType>({
    item,
    routePrefix,
    testId,
    badge,
    metaTag,
    note,
    renderExpandedActions,
    renderExpandedContent,
}: TaskItemProps<T>) {
    const to = routePrefix === '/not-found' ? '/not-found' : `${routePrefix}/${item.id}`;

    const content = <TaskItemHeader item={item} badge={badge} metaTag={metaTag} note={note} />;

    const hasActions = Boolean(renderExpandedActions);
    const rowClass = 'flex items-center w-full pt-m pb-l px-l text-left';
    const cardClass = `flex flex-col rounded-lg border border-line-card bg-surface-elevated shadow-weak overflow-hidden${item.isCompleted ? ' opacity-60' : ''}`;

    return (
        <li role="listitem" data-testid={testId ?? `home-task-item-${item.id}`} className={cardClass}>
            {item.isCompleted ? (
                <span className={`${rowClass} cursor-default`}>{content}</span>
            ) : hasActions ? (
                <>
                    <div data-testid={`home-task-item-btn-${item.id}`} className="flex items-center w-full pt-m px-l text-left">
                        {content}
                    </div>
                    {renderExpandedContent && (
                        <div className="px-l py-m empty:hidden">
                            {renderExpandedContent({ item })}
                        </div>
                    )}
                    {renderExpandedActions?.({ item, to })}
                </>
            ) : (
                <Link
                    to={to}
                    data-testid={`home-task-item-btn-${item.id}`}
                    className={`${rowClass} hover:bg-overlay-weak cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary-500`}
                >
                    {content}
                </Link>
            )}
        </li>
    );
}
